// extracted by mini-css-extract-plugin
module.exports = {"announceBarWrapper":"announceBar_announceBarWrapper__29qrr","announceBar":"announceBar_announceBar__1RFXy","blackBorderSmall":"announceBar_blackBorderSmall__3cx2J"};